import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "axisId"];
import * as React from 'react';
import { useRef, useEffect, Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';
import { useAxis, useModifiedProps, getNonEventHandlerProps } from 'react-jsx-highcharts';

var NavigatorAxis = function NavigatorAxis(_ref) {
  var children = _ref.children,
      axisId = _ref.axisId,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var axis = useAxis(axisId);
  var renderedRef = useRef(false);
  useEffect(function () {
    if (!axis) return;
    updateNavigatorAxis(getNonEventHandlerProps(restProps), axis);
  }, [axis]);
  var modifiedProps = useModifiedProps(restProps);
  useEffect(function () {
    if (!renderedRef.current) {
      // don't update on first render
      renderedRef.current = true;
      return;
    }

    if (!axis) return;

    if (modifiedProps !== false) {
      updateNavigatorAxis(modifiedProps, axis);
    }
  });
  if (!children) return null;
  var axisChildren = Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child) === false) return child;
    return /*#__PURE__*/cloneElement(child, {
      axisId: axisId
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, axisChildren);
};

var updateNavigatorAxis = function updateNavigatorAxis(config, axis) {
  axis.update(config);
};

export default NavigatorAxis;